import { Route, Routes } from "react-router-dom";
import "./App.css";
import Home from "./pages/Home";
import Error from "./pages/Error";
import Header from "./components/Header";
import Chapters from "./pages/Chapters";
import Solution from "./pages/Solution";
import Footer from "./components/Footer";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Contact from "./pages/Contact";
import About from "./pages/About";
import Subject from "./pages/Subject";

function App() {
  return (
    <div>
      <Header />
      <div className={`min-70vh`}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/:type/:class_name/:subject" element={<Chapters />} />
          <Route
            path="/solutions/:type/:class_name/:subject/:chapter/:id"
            element={<Solution />}
          />
          <Route path="/:class_name" element={<Subject />} />
          <Route path="/about" element={<About />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<Error />} />
        </Routes>
      </div>
      <Footer />
    </div>
  );
}

export default App;
